import { render, staticRenderFns } from "./AIQnaInitialEvaluation.vue?vue&type=template&id=46377994&scoped=true&"
import script from "./AIQnaInitialEvaluation.vue?vue&type=script&lang=js&"
export * from "./AIQnaInitialEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./AIQnaInitialEvaluation.vue?vue&type=style&index=0&id=46377994&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46377994",
  null
  
)

export default component.exports